<template>
  <div class="tournament-page">
    <section class="tournament-not-found" v-if="isTournamentAccessDenied" role="alert">
      <div class="not-found-icon" aria-hidden="true"><tkd-icon name="lock"/></div>
      <h1>Турнір не знайдено</h1>
      <p>Перевірте посилання або відкрийте список своїх турнірів.</p>
      <router-link class="not-found-link" to="/user/tournaments">До списку турнірів</router-link>
    </section>

    <!--    Общая информация о турнире-->
    <info-navbar v-if="!isTournamentAccessDenied"></info-navbar>

    <!--      Таби меню управления турніром-->
    <control-tabs v-if="!isTournamentAccessDenied && tournamentOne.data && tournamentOne.data.item"></control-tabs>

    <div class="container-fluid" v-if="!isTournamentAccessDenied && tournamentOne.data  && tournamentOne.data.item">
      <!--      Таба УЧАСНИКОВ-->
      <tab-sportsmans></tab-sportsmans>

      <!--      Таба КАТЕГОРИИ-->
      <tab-categories></tab-categories>

      <!--      Таба ЖЕРЕБКУВАННЯ-->
      <tab-drawing :category="category"></tab-drawing>

      <!--      Таба ПОЄДИНКИ (по відділеннях) -->
      <tab-fights></tab-fights>


      <!--      Таба Розбивка поєдинків -->
      <tab-category-sections></tab-category-sections>


      <!--      Таба РЕЗУЛЬТАТИ-->
      <tab-results :category="category"></tab-results>

<!--      <div class="tournament-content-tab" v-bind:class="{'tournament-content-active-tab':activeTab == 6}">
        <div class="row">
          <div class="col-md-12">
            <card>
              <template slot="header">
                <h4 class="title">Функціонал в розробці й буде доступний найближчим часом1</h4>
              </template>
            </card>
          </div>
        </div>
      </div>-->

      <tab-sportsmans-cards></tab-sportsmans-cards>

      <!--      Таба ЕЛЕКТРОННА СИСТЕМА (повідомлення від пристроїв) -->
      <tab-devices></tab-devices>
    </div>


    <tab-info v-if="!isTournamentAccessDenied"></tab-info>
  </div>
</template>

<script>


  import axios from 'axios';
  import ChartCard from 'src/components/Cards/ChartCard.vue'
  import StatsCard from 'src/components/Cards/StatsCard.vue'
  import LTable from 'src/components/Table.vue'
  // import UserBracketsContructor from  'src/pages/user/UserBracketsContructor.vue';
  import {Sortable, Plugins, DragStartEvent, DragStopEvent} from '@shopify/draggable';
  import UserBracketsContructor from 'src/pages/tools/UserBracketsContructor.vue';
  import ListContructor from 'src/pages/tools/ListContructor.vue';
  import ResultContructor from 'src/pages/tools/ResultContructor.vue';
  import ListContructorNew from 'src/pages/tools/ListContructorNew.vue';
  import InfoNavbar from 'src/pages/tournament/_infoNavbar.vue';
  import ControlTabs from 'src/pages/tournament/_controlTabs.vue';
  import TabSportsmans from 'src/pages/tournament/_tabSportsmans.vue';
  import TabSportsmansCards from 'src/pages/tournament/_tabSportsmansCards.vue';
  import TabCategories from 'src/pages/tournament/_tabCategories.vue';
  import TabCategorySection from 'src/pages/tournament/_tabCategorySection.vue';
  import TabDrawing from 'src/pages/tournament/_tabDrawing.vue';
  import TabResults from 'src/pages/tournament/_tabResults.vue';
  import TabDevices from 'src/pages/tournament/_tabDevices.vue';
  import TabFights from 'src/pages/tournament/_tabFights.vue';
  import TabInfo from 'src/pages/tournament/_tabInfo.vue';
  import {regions} from 'src/utils/dictionary.js';

  import Cookie from "js-cookie";
  import {baseUrlServer} from '../../api/user';

  const TAB_ID_BY_QUERY = {
    info: 1,
    sportsmans: 2,
    drawing: 4,
    results: 6,
    categories: 7,
    numeration: 11,
    badges: 12,
    'new-tab': 12,
    devices: 13,
    fights: 14,
  };

  const TAB_QUERY_BY_ID = {
    1: 'info',
    2: 'sportsmans',
    4: 'drawing',
    6: 'results',
    7: 'categories',
    11: 'numeration',
    12: 'badges',
    13: 'devices',
    14: 'fights',
  };

  export default {
    props: ['id', 'category'],
    components: {
      LTable,
      ChartCard,
      StatsCard,
      'list-constructor-new': ListContructorNew,
      'list-constructor': ListContructor,
      'result-constructor': ResultContructor,
      'brackets-constructor': UserBracketsContructor,
      'info-navbar': InfoNavbar,
      'control-tabs': ControlTabs,
      'tab-sportsmans': TabSportsmans,
      'tab-sportsmans-cards': TabSportsmansCards,
      'tab-categories': TabCategories,
      'tab-drawing': TabDrawing,
      'tab-results': TabResults,
      'tab-devices': TabDevices,
      'tab-fights': TabFights,
      'tab-info': TabInfo,
      'tab-category-sections': TabCategorySection,
      Sortable, Plugins, DragStartEvent, DragStopEvent
    },
    data() {
      return {
        selectedDrawCategory: {},
        baseUrlServer: '',
        hideEmptyCategories: false,
        showBracketCategories: false,
        regions: [],
        file: '',
      }
    },

    computed: {
      activeTab() {
        return this.$store.getters['settings/activeTournamentTab'];
      },

      sortedCategories: function () {

      },

      tournamentOne() {
        return this.$store.getters['tournament/tournamentOne'];
      },
      currentUser() {
        const userOne = this.$store.getters['user/userOne'];
        return userOne && userOne.data ? userOne.data.user : null;
      },
      tournamentItem() {
        return this.tournamentOne && this.tournamentOne.data ? this.tournamentOne.data.item : null;
      },
      tournamentOwnerId() {
        const item = this.tournamentItem;
        if (!item) {
          return null;
        }
        const ownerId = [item.id_user, item.user_id, item.user]
          .find(value => value !== undefined && value !== null && value !== '');
        return ownerId === undefined ? null : ownerId;
      },
      isTournamentAccessDenied() {
        const userId = this.currentUser && this.currentUser.id;
        return this.tournamentOwnerId !== null
          && userId !== undefined
          && userId !== null
          && Number(this.tournamentOwnerId) !== Number(userId);
      },
    },
    beforeMount() {
      this.regions = regions;
    },
    mounted() {
      if (this.id != undefined) {
        this.$store.dispatch('tournament/fetchTournamentOneFull', {id: this.id});
      }
      this.syncTabFromUrl();
      this.ensureTabQueryInUrl();
    },
    watch: {
      '$route.query.tab'() {
        this.syncTabFromUrl();
      },
    },
    created(){
      this.baseUrlServer = baseUrlServer;
    },
    methods: {
      syncTabFromUrl() {
        const tabQueryValue = (this.$route.query.tab || '').toString().toLowerCase();
        const tabFromQuery = TAB_ID_BY_QUERY[tabQueryValue];

        if (tabFromQuery) {
          this.$store.dispatch('settings/setActiveTournamentTab', tabFromQuery);
          return;
        }

        if (this.category != undefined) {
          this.$store.dispatch('settings/setActiveTournamentTab', 4);
          return;
        }

        this.$store.dispatch('settings/setActiveTournamentTab', 1);
      },

      ensureTabQueryInUrl() {
        const tabQueryValue = (this.$route.query.tab || '').toString().toLowerCase();
        if (TAB_ID_BY_QUERY[tabQueryValue]) {
          return;
        }

        const activeTabValue = this.$store.getters['settings/activeTournamentTab'];
        const fallbackTab = this.category != undefined ? 'drawing' : 'info';
        const normalizedTab = TAB_QUERY_BY_ID[activeTabValue] || fallbackTab;
        this.$router.replace({
          query: {
            ...this.$route.query,
            tab: normalizedTab,
          },
        }).catch(() => {});
      },

      selectDrawCategory(category) {
        this.selectedDrawCategory = category;
      },


      // выгрузка файла CSV на сервер
      handleFileUpload() {
        this.file = this.$refs.file.files[0];

        let formData = new FormData();
        formData.append('id', this.id);
        formData.append('file', this.file);

        this.$store.dispatch('tournament/uploadFileCSV', formData).then(() => this.fetchTournamentOneFull());
      },
      fetchTournamentOneFull() {
        this.$store.dispatch('tournament/fetchTournamentOneFull', {id: this.id});
      },


      clickHideEmptyCategories() {
        // console.log(clickHideEmptyCategories)
        if (this.hideEmptyCategories == true) {
          this.hideEmptyCategories = false;
        } else {
          this.hideEmptyCategories = true;
        }
      },
      clickShowBracketCategories() {
        // console.log(clickHideEmptyCategories)
        if (this.showBracketCategories == true) {
          this.showBracketCategories = false;
        } else {
          this.showBracketCategories = true;
        }
      },
    },
  }
</script>
<style scoped>
  .tournament-page {
    width: 100%;
    padding: 30px 15px 40px;
  }

  .tournament-page > .container-fluid { padding: 0; }

  .tournament-not-found {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 360px;
    padding: 40px 20px;
    border: 1px solid var(--tkd-border);
    border-radius: var(--tkd-radius-lg);
    background: var(--tkd-surface);
    box-shadow: var(--tkd-shadow);
    text-align: center;
    color: var(--tkd-text);
  }

  .not-found-icon { margin-bottom: 12px; font-size: 42px; }
  .tournament-not-found h1 { margin: 0 0 8px; font-size: 28px; }
  .tournament-not-found p { margin: 0 0 20px; color: var(--tkd-muted); }
  .not-found-link {
    display: inline-flex;
    align-items: center;
    min-height: 42px;
    padding: 0 16px;
    border-radius: var(--tkd-radius);
    background: var(--tkd-navy);
    color: #fff;
    font-weight: 700;
    text-decoration: none;
  }
  .not-found-link:hover { background: var(--tkd-navy-dark); color: #fff; text-decoration: none; }
</style>
